import type { HeaderSetting } from '/#/config';

import { computed, unref } from 'vue';

import { useAppStore } from '@/store/modules/app';

import { useMenuSetting } from '@/hooks/setting/useMenuSetting';
import { useRootSetting } from '@/hooks/setting/useRootSetting';
import { useFullContent } from '@/hooks/web/useFullContent';
import { MenuModeEnum } from '@/enums/menuEnum';
import {StorageUtils} from 'xmgoing-utils';
import {RoleEnum} from "@/enums/roleEnum";

export function useHeaderSetting() {
  const { getFullContent } = useFullContent();
  const appStore = useAppStore();

  const getShowFullHeaderRef = computed(() => {
    return (
      !unref(getFullContent) &&
      unref(getShowMixHeaderRef) &&
      unref(getShowHeader) &&
      !unref(getIsTopMenu) &&
      !unref(getIsMixSidebar)
    );
  });

  const getUnFixedAndFull = computed(() => !unref(getFixed) && !unref(getShowFullHeaderRef));

  const getShowInsetHeaderRef = computed(() => {
    const need = !unref(getFullContent) && unref(getShowHeader);
    return (
      (need && !unref(getShowMixHeaderRef)) ||
      (need && unref(getIsTopMenu)) ||
      (need && unref(getIsMixSidebar))
    );
  });

  const {
    getMenuMode,
    getSplit,
    getShowHeaderTrigger,
    getIsSidebarType,
    getIsMixSidebar,
    getIsTopMenu,
  } = useMenuSetting();
  const { getShowBreadCrumb, getShowLogo } = useRootSetting();

  const getPageBgColor= computed(() => appStore.getProjectConfig.pageBgColor);
  //背景显示类型
  const getBackShowType= computed(() => appStore.getProjectConfig.pageBgShowType);
  //背景图片地址
  const getPageBgImgSrc= computed(() => appStore.getProjectConfig.pageBgImgSrc);
  //获取显示空间组件
  const getShowSpaceSel=computed(() => {
    if(StorageUtils.getSessionItem("loginUserType")===RoleEnum.USER_UNIT_ROLE){
      if (StorageUtils.getSessionItem("closeUnitSpaceSel")==="true") {
        return false;
      }
    }
    if(StorageUtils.getSessionItem("loginUserType")===RoleEnum.USER_GROUP_ADMIN_ROLE){
      if (StorageUtils.getSessionItem("closeGroupSpaceSel")==="true") {
        return false;
      }
    }
    if(StorageUtils.getSessionItem("loginUserType")===RoleEnum.USER_ROLE){
      if (StorageUtils.getSessionItem("closeUserSpaceSel")==="true") {
        return false;
      }
    }
    return appStore.getProjectConfig.showSpaceSel||true;
  });
  //背景模糊度
  const getPageBgFilterVal= computed(() => appStore.getProjectConfig.pageBgFilterVal);
  //编辑状态标志
  const getEditoringFlag = computed(() => appStore.getHeaderSetting.editoring);
  //背景蒙层
  const getPageBgOpAcityVal= computed(() => appStore.getProjectConfig.pageBgOpAcityVal);
  //获取蒙层的颜色
  const getMaskColor= computed(() => appStore.getProjectConfig.pageMaskColor);
  //获取界面卡片间距信息
  const getPageCardSpace= computed(() => appStore.getProjectConfig.pageCardSpace);

  const getShowMixHeaderRef = computed(() => !unref(getIsSidebarType) && unref(getShowHeader));

  const getIconColor = computed(() => appStore.getHeaderSetting.iconColor);

  const getShowDoc = computed(() => appStore.getHeaderSetting.showDoc);

  const getHeaderTheme = computed(() => appStore.getHeaderSetting.theme);

  const getShowHeader = computed(() => appStore.getHeaderSetting.show);

  const getPrimaryColor=computed(() => appStore.getProjectConfig.themeColor);

  const getFixed = computed(() => appStore.getHeaderSetting.fixed);

  const getHeaderBgColor = computed(() => appStore.getHeaderSetting.bgColor);

  const getShowSystemTitle= computed(() => {
    if(appStore.getHeaderSetting.showSystemTitle==null||appStore.getHeaderSetting.showSystemTitle===""){
      appStore.getHeaderSetting.showSystemTitle=true;
    }
    return appStore.getHeaderSetting.showSystemTitle;
  });
  const getShowApp = computed(() => appStore.getHeaderSetting.showApp);

  const getShowSearch = computed(() => appStore.getHeaderSetting.showSearch);

  const getUseLockPage = computed(() => appStore.getHeaderSetting.useLockPage);

  const getShowFullScreen = computed(() => appStore.getHeaderSetting.showFullScreen);

  const getShowHelp= computed(() => appStore.getHeaderSetting.showHelp);

  const getShowNotice = computed(() => appStore.getHeaderSetting.showNotice);

  const getShowCalling = computed(() => appStore.getHeaderSetting.showCalling);

  const getShowBread = computed(() => {
    return (
      unref(getMenuMode) !== MenuModeEnum.HORIZONTAL && unref(getShowBreadCrumb) && !unref(getSplit)
    );
  });

  const getShowHeaderLogo = computed(() => {
    return unref(getShowLogo) && !unref(getIsSidebarType) && !unref(getIsMixSidebar);
  });

  const getShowContent = computed(() => {
    return unref(getShowBread) || unref(getShowHeaderTrigger);
  });

  // Set header configuration
  function setHeaderSetting(headerSetting: Partial<HeaderSetting>) {
    appStore.setProjectConfig({ headerSetting });
  }
  return {
    getShowCalling,
    getShowApp,
    getIconColor,
    getShowSystemTitle,
    getShowSpaceSel,
    getPageCardSpace,
    setHeaderSetting,
    getPageBgOpAcityVal,
    getMaskColor,
    getPageBgFilterVal,
    getBackShowType,
    getPageBgImgSrc,
    getPageBgColor,
    getShowDoc,
    getShowSearch,
    getHeaderTheme,
    getUseLockPage,
    getShowHelp,
    getShowFullScreen,
    getShowNotice,
    getShowBread,
    getShowContent,
    getShowHeaderLogo,
    getShowHeader,
    getFixed,
    getShowMixHeaderRef,
    getShowFullHeaderRef,
    getShowInsetHeaderRef,
    getUnFixedAndFull,
    getPrimaryColor,
    getEditoringFlag,
    getHeaderBgColor,
  };
}
